var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":"","class-name":"z-50","z-index":"3000"}},[_c('div',{staticClass:"wrapper"},[_c('van-loading',{attrs:{"vertical":""}},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }